window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.leave_project_group_confirmation_modal = window.locales.am.leave_project_group_confirmation_modal || {};window.locales.am.leave_project_group_confirmation_modal = {...window.locales.am.leave_project_group_confirmation_modal, ...{
    "title": "የፕሮጀክት ቡድንን ተው",
    "message": "ይህንን የፕሮጀክት ቡድን መተው እርግጠኛ ነዎት? ይህ እርምጃ ሊለወጥ አይችልም።",
    "cancel_button_label": "ሰርዝ",
    "confirm_button_label": "ቡድን ተው",
    "confirm_button_loading_label": "እየተወ..."
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.leave_project_group_confirmation_modal = window.locales.ar.leave_project_group_confirmation_modal || {};window.locales.ar.leave_project_group_confirmation_modal = {...window.locales.ar.leave_project_group_confirmation_modal, ...{
    "title": "ترك مجموعة المشروع",
    "message": "هل أنت متأكد من أنك تريد ترك هذه المجموعة؟ لا يمكن التراجع عن هذا الإجراء.",
    "cancel_button_label": "إلغاء",
    "confirm_button_label": "ترك المجموعة",
    "confirm_button_loading_label": "جاري الخروج..."
}
};window.locales.en = window.locales.en || {};window.locales.en.leave_project_group_confirmation_modal = window.locales.en.leave_project_group_confirmation_modal || {};window.locales.en.leave_project_group_confirmation_modal = {...window.locales.en.leave_project_group_confirmation_modal, ...{
    "title": "Leave project group",
    "message": "Are you sure you want to leave this project group? This action cannot be undone.",
    "cancel_button_label": "Cancel",
    "confirm_button_label": "Leave Group",
    "confirm_button_loading_label": "Leaving..."
}
};window.locales.es = window.locales.es || {};window.locales.es.leave_project_group_confirmation_modal = window.locales.es.leave_project_group_confirmation_modal || {};window.locales.es.leave_project_group_confirmation_modal = {...window.locales.es.leave_project_group_confirmation_modal, ...{
    "title": "Salir del grupo de proyecto",
    "message": "¿Estás seguro de que quieres salir de este grupo de proyecto? Esta acción no se puede deshacer.",
    "cancel_button_label": "Cancelar",
    "confirm_button_label": "Salir del Grupo",
    "confirm_button_loading_label": "Saliendo..."
}
};window.locales.it = window.locales.it || {};window.locales.it.leave_project_group_confirmation_modal = window.locales.it.leave_project_group_confirmation_modal || {};window.locales.it.leave_project_group_confirmation_modal = {...window.locales.it.leave_project_group_confirmation_modal, ...{
    "title": "Lascia il gruppo del progetto",
    "message": "Sei sicuro di voler lasciare questo gruppo del progetto? Questa azione non può essere annullata.",
    "cancel_button_label": "Annulla",
    "confirm_button_label": "Lascia il Gruppo",
    "confirm_button_loading_label": "Uscendo..."
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.leave_project_group_confirmation_modal = window.locales.zh.leave_project_group_confirmation_modal || {};window.locales.zh.leave_project_group_confirmation_modal = {...window.locales.zh.leave_project_group_confirmation_modal, ...{
    "title": "离开项目组",
    "message": "您确定要离开这个项目组吗？此操作无法撤销。",
    "cancel_button_label": "取消",
    "confirm_button_label": "离开组",
    "confirm_button_loading_label": "正在离开..."
}
};